import React from 'react';
import GlobalContext from '../GlobalContext';

export default function DocRoot() {

    let first = BWDM();
    let second = CLP();
    let third = CDM();
    let fourth = LVBW();
    let fifth = MVBW();
    let sixth = LVCM();
    let seventh = MVCM();
    let eighth = HVPC();
    let wide = WideF();
    let scan = CanoScan();

    const paths = GlobalContext().paths;
    return (
        <div className="container">
            <img id="root-top-logo-canon" height="80px" src={paths.pictures + "canon-logo.jpg"}></img>
            <p className="c-font-2">Browse Product Categories</p>
            <div class="accordion" id="canonAccordion">
                <div className="canonSection1">
                    {/*COLLAPSE HEAD 0*/}
                    <a href="#collapseLaser" data-toggle="collapse">
                        <div className=" canonHead">
                            LASER PRINTERS
                        </div>
                    </a>
                    {/*COLLAPSE BODY 0*/}
                    <div id="collapseLaser" class="collapse" data-parent="#canonAccordion">
                        {/*BLACK & WHITE DESKTOP MULTIFUNCTION*/}
                        <SubSectionRender category={first} parent={"collapseLaser"} />
                        {/*COLOR LASER PRINTERS*/}
                        <SubSectionRender category={second} parent={"collapseLaser"} />
                        {/*COLOR DESKTOP MULTIFUNCTION*/}
                        <SubSectionRender category={third} parent={"collapseLaser"} />
                        {/*LOW VOLUME BLACK & WHITE MULTIFUNCTION*/}
                        <SubSectionRender category={fourth} parent={"collapseLaser"} />
                        {/*MID VOLUME BLACK & WHITE MULTIFUNCTION*/}
                        <SubSectionRender category={fifth} parent={"collapseLaser"} />
                        {/*LOW VOLUME COLOR MULTIFUNCTION*/}
                        <SubSectionRender category={sixth} parent={"collapseLaser"} />
                        {/*MID VOLUME COLOR MULTIFUNCTION*/}
                        <SubSectionRender category={seventh} parent={"collapseLaser"} />
                        {/*HIGH VOLUME PRODUCTION COLOR*/}
                        <SubSectionRender category={eighth} parent={"collapseLaser"} />
                    </div>
                </div>
                <div className="canonSection1">
                    {/*WIDEFORMAT PRINTERS*/}
                    <SubSectionRender category={wide} parent={"canonAccordion"} level={1} />
                </div>
                <div className="canonSection1">
                    {/*DOCUMENT SCANNERS*/}
                    <SubSectionRender category={scan} parent={"canonAccordion"} level={1} />
                </div>
            </div>
        </div>
    );
}

const SubSectionRender = (props) => {
    let level = "canonSection2";
    if (props.level && props.level === 1)
        level = "canonHead";
    return (
        <>
            {/*COLLAPSE HEAD 1*/}
            <a href={"#" + props.category.sectionId} data-toggle="collapse">
                <div className={level}>
                    {props.category.sectionName}
                </div>
            </a>
            {/*COLLAPSE BODY 1*/}
            <div id={props.category.sectionId} className="canonSectionBody collapse" data-parent={"#" + props.parent}>
                <div className="canonCardDeck row">
                    {
                        props.category.items.map((_item, _index) => (<CardRender
                            text={_item.text}
                            link={_item.link}
                            title={_item.title}
                            image={_item.image}
                        />))
                    }
                </div>
            </div>
        </>
    )
}
const CardRender = (props) => {
    const paths = GlobalContext().paths;
    return (
        <div className="col-md-4">
            <div className="canon-card">
                <div className="canon-card-header">
                    <h3 class="card-title">{props.title}</h3>
                </div>
                <img src={paths.pictures + props.image} class="card-img-top card-height" alt="..." />
                <div>
                    <p class="card-text text-center">{props.text}</p>
                    <a href={props.link} class="btn btn-block card-btn">Learn More</a>
                </div>
            </div>
        </div>
    )
}


//categories

const BWDM = () => {

    let itemsArr = [MF264(), IR1643()];

    let c100000 = {
        sectionName: "BLACK & WHITE DESKTOP MULTIFUNCTION",
        sectionId: "c100000",
        items: itemsArr
    }

    return c100000;
}
const CLP = () => {
    let itemsArr = [LBP664(), LBP622()];

    let c110000 = {
        sectionName: "COLOR LASER PRINTERS",
        sectionId: "c110000",
        items: itemsArr
    }

    return c110000;
}
const CDM = () => {
    let itemsArr = [MF746(), MF644()];

    let c120000 = {
        sectionName: "COLOR DESKTOP MULTIFUNCTION",
        sectionId: "c120000",
        items: itemsArr
    }

    return c120000;
}
const LVBW = () => {
    let itemsArr = [IR525()];

    let c130000 = {
        sectionName: "LOW VOLUME BLACK & WHITE MULTIFUNCTION",
        sectionId: "c130000",
        items: itemsArr
    }

    return c130000;
}
const MVBW = () => {
    let itemsArr = [IR4535()];

    let c140000 = {
        sectionName: "MID VOLUME BLACK & WHITE MULTIFUNCTION",
        sectionId: "c140000",
        items: itemsArr
    }

    return c140000;
}
const LVCM = () => {
    let itemsArr = [IRC356()];

    let c150000 = {
        sectionName: "LOW VOLUME COLOR MULTIFUNCTION",
        sectionId: "c150000",
        items: itemsArr
    }

    return c150000;
}
const MVCM = () => {
    let itemsArr = [IRC5550(), IRC3500()];

    let c160000 = {
        sectionName: "MID VOLUME COLOR MULTIFUNCTION",
        sectionId: "c160000",
        items: itemsArr
    }

    return c160000;
}
const HVPC = () => {
    let itemsArr = [IRC910()];

    let c170000 = {
        sectionName: "HIGH VOLUME PRODUCTION COLOR",
        sectionId: "c170000",
        items: itemsArr
    }

    return c170000;
}
const WideF = () => {
    let itemsArr = [IPF770(), IPF785()];

    let c180000 = {
        sectionName: "WIDEFORMAT PRINTERS",
        sectionId: "c180000",
        items: itemsArr
    }

    return c180000;
}
const CanoScan = () => {
    let itemsArr = [DRC225(), DRM140(), DRF120()];

    let c190000 = {
        sectionName: "DOCUMENT SCANNERS",
        sectionId: "c190000",
        items: itemsArr
    }

    return c190000;
}

//individual machines

const MF264 = () => {

    return ({
        text: "PRODUCTIVE PRINTING THAT MAKES BUSINESS SENSE.",
        link: "/static_page/mf264cdw",
        title: "MF 264Cdw",
        image: "264cdw.jpg"
    })
}

const IR1643 = () => {
    return (
        {
            text: "BLACK & WHITE MULTIFUNCTION PRINTER.",
            link: "/canon_equipment/aae3bea14b4f489cb32dcfef519534ef",
            title: "IR1643",
            image: "ir1643.jpg"
        }
    )
}

const LBP664 = () => {
    return (
        {
            text: "COLOR | COMPACT | PRINTER",
            link: "/canon_equipment/1acd40b74c2a46899890748f7739d977",
            title: "LBP664Cdw",
            image: "t_LBP664Cdw.jpg"
        }

    )
}

const LBP622 = () => {
    return (
        {
            text: "COLOR | COMPACT | PRINTER",
            link: "/canon_equipment/a266b5a362b4430b9c2b6cc3e89a3432",
            title: "LBP622Cdw",
            image: "t_LBP622Cdw.jpg"
        }

    )
}

const MF746 = () => {
    return (
        {
            text: "Color | Compact | Multifunction",
            link: "/canon_equipment/f7ba9dd4aecf4a65b63642b4afd7ecd2",
            title: "MF 746",
            image: "t_MF746Cdw.jpg"
        }
    )
}

const MF644 = () => {
    return (
        {
            text: "Color | Compact | Multifunction",
            link: "/canon_equipment/fde101b2a1834ac6b6f74de7bcce4137",
            title: "MF 644",
            image: "t_MF644Cdw.jpg"
        }

    )
}

const IR525 = () => {
    return (
        {
            text: "Black-and-White | Compact | Multifunction",
            link: "/canon_equipment/e8bb574225864b639cdda603b3e1631c",
            title: "IR 525if",
            image: "525if.jpg"
        }

    )
}

const IR4535 = () => {
    return (
        {
            text: "Black-and-White | Mid-Volume | Multifunction",
            link: "/canon_equipment/701788f47ce14e1b9f0872ff32608589",
            title: "IR 4535",
            image: "t_4500.jpg"
        }

    )
}

const IRC356 = () => {
    return (
        {
            text: "Color | Compact | Multifunction",
            link: "/canon_equipment/d7fee75854aa45218a5ffb48ec006006",
            title: "IRC 356",
            image: "t_C356iF.jpg"
        }

    )
}

const IRC5550 = () => {
    return (
        {
            text: "Color | Mid-volume | Multifunction",
            link: "/canon_equipment/a5c0e352e5fa4da5bd0db6394185ad55",
            title: "IRC 5550i",
            image: "t_c5500.jpg"
        }
    )
}

const IRC3500 = () => {
    return (
        {
            text: "Color | Low- to Mid-volume | Multifunction",
            link: "/canon_equipment/f56f937e6ea64e76afc7440eeb1749f5",
            title: "IRC 3500",
            image: "t_c3500.jpg"
        }
    )
}

const IRC910 = () => {
    return (
        {
            text: "HIGH VOLUME PRODUCTION COLOR",
            link: "/static_page/c910",
            title: "IRC 910",
            image: "c910.jpg"
        }
    )
}

const IPF770 = () => {
    return (
        {
            text: "WIDEFORMAT PRO SERIES",
            link: "/static_page/ipf770",
            title: "iPF770",
            image: "ipf770.jpg"
        }
    )
}

const IPF785 = () => {
    return (
        {
            text: "WIDEFORMAT PRO SERIES",
            link: "/static_page/ipf785",
            title: "iPF 785",
            image: "ipf780.jpg"
        }
    )
}



const DRC225 = () => {
    return (
        {
            text: "Optional Flatbed Scanner",
            link: "/static_page/drc225",
            title: "DR-C225",
            image: "drc225main.jpg"
        }
    )
}

const DRM140 = () => {
    return (
        {
            text: "Office Document Scanner",
            link: "/static_page/drm140",
            title: "DR-M140",
            image: "drm140main.jpg"
        }

    )
}

const DRF120 = () => {
    return (
        {
            text: "Office Document Scanner",
            link: "/static_page/drf120",
            title: "DR-F120",
            image: "drf120main.jpg"
        }
    )
}

